import { useAuth } from "@/features/auth/hooks/useAuth";
import { usePlan } from "@/features/auth/hooks/usePlan";
import { PurchasePointsSummary } from "@/features/purchasePoints/components/SummaryWidget/PurchasePointsSummary";

/**
 * Reads the session through `usePlan` and `useAuth` rather than `useUser`,
 * which creates a fresh mutation on every call and would serialise this
 * widget's render with any other consumer's save.
 *
 * Strictly `true`, never a bare negation: `allow_purchase_points` is
 * `undefined` while the session loads, and a falsy check would flash the
 * widget shut on an employee who does take part.
 */
export const PurchasePointsSummaryWidget = () => {
  const isProgrammeOpenToOrganisation = usePlan()?.features.service_cashback === true;
  const isEmployeeParticipating = useAuth().user?.employee?.allow_purchase_points === true;

  if (!isProgrammeOpenToOrganisation || !isEmployeeParticipating) return null;

  return <PurchasePointsSummary />;
};

PurchasePointsSummaryWidget.displayName = "PurchasePointsSummaryWidget";
